import React from 'react';
import {Content, Title, WidgetWrapper} from './Widget.styled';

const Widget = ({title, children}) => {
	return (
		<>
			<WidgetWrapper>
				<Title>{title}</Title>
				<Content>{children}</Content>
			</WidgetWrapper>
		</>
	);
};

export default Widget;
